module.exports = __webpack_public_path__ + "static/media/biutti.a8e0e704.jpg";